export class NotFound {
	render() {
		return '<p>NotFound</p>'
	}
}
